import './signInWithAmazon.scss';

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Spinner, Card, Button, Alert } from 'components/base';
import classNames from 'classnames';
import Icon, { ICON_TYPE } from 'components/icon';
import useModalContext from 'components/context/modal';

import { prepareAmazonLogin, amazonLogout } from '../hoc/withAmazon';

const SignInWithAmazon = props => {
  const modalContext = useModalContext();
  const [isAvailable, setIsAvailable] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const handleOnFailed = error => {
    modalContext.hideSpinner();

    if (error === 'unavailable') {
      setIsAvailable(false);
    } else {
      modalContext.toast(error, { type: 'warning' });
      props.onFailed(error);
    }
  };

  useEffect(() => {
    prepareAmazonLogin(
      'amazon-login-button',
      props.redirectUrl,
      amazonToken => {
        setIsLoading(true);
        props.onLoading({ amazonToken });
        modalContext.spinner(<>Getting your Amazon account...</>, {
          title: 'Login with Amazon',
        });
      },
      async (amazonToken, getProfile) => {
        setIsLoading(true);
        const profile = await getProfile();

        const amazonEmail = profile.PrimaryEmail;
        const amazonCustomerId = profile.CustomerId;

        if (amazonEmail) {
          await props.onSuccess({ id: amazonCustomerId, token: amazonToken, email: amazonEmail });
          modalContext.hideSpinner();
          setIsLoading(false);
        } else {
          handleOnFailed(
            'We need your email address. Please allow us to get email address from your Amazon account. Otherwise we can not sign you in.',
          );
        }
      },
      error => {
        amazonLogout();
        handleOnFailed(error);
        setIsLoading(false);
      },
    );
  }, []);

  return (
    <div className={props.className}>
      <div style={{ height: 46 }}>
        <Spinner theme="warning" className={isLoading ? 'd-inline-block' : 'd-none'} />
        <div
          id="amazon-login-button"
          className={isLoading || !isAvailable ? 'd-none' : 'd-block'}
        />
        {!isAvailable && <Alert type="warning">Amazon Pay is temporarily unavailable</Alert>}
      </div>
    </div>
  );
};

SignInWithAmazon.propTypes = {
  onLoading: PropTypes.func,
  onSuccess: PropTypes.func,
  onFailed: PropTypes.func,
  redirectUrl: PropTypes.string,
  className: PropTypes.string,
};

SignInWithAmazon.defaultProps = {
  redirectUrl: '/signin',
  onLoading: () => {},
  onFailed: console.error,
};

export const SignInWithAmazonToggler = ({ key = 'amazon', toggler, children, className }) => {
  const isOpen = toggler[0] === key;

  return (
    <Card className={classNames(isOpen ? 'border-black' : 'border-white', className)}>
      <Button
        type={isOpen ? 'default' : 'amazon'}
        className="w-100 text-black transition-none"
        size="sm"
        onClick={() => {
          toggler[1](val => (val === key ? undefined : key));
        }}
      >
        <Icon
          type={ICON_TYPE.AMAZON}
          className="position-absolute"
          size={22}
          style={{ left: 15 }}
        />
        <span>Continue with Amazon</span>
      </Button>
      <Card.Body className={isOpen ? 'd-block' : 'd-none'}>{children}</Card.Body>
    </Card>
  );
};

export default SignInWithAmazon;
